module.exports = __webpack_public_path__ + "img/01.343852f3.jpg";